<template>
  <div class="content">
    <div id="Map"></div>
    <el-radio-group v-model="radio1" class="radio" @change="changeMap">
      <el-radio-button label="卫星"></el-radio-button>
      <el-radio-button label="普通"></el-radio-button>
    </el-radio-group>
    <MapInfoQiao
      v-show="infowindow"
      :infowData="infowData"
      ref="infowindow"
    ></MapInfoQiao>
    <MapInfoAn
      v-show="infowindowan"
      :inanjuanData="inanjuanData"
      ref="infowindowan"
    ></MapInfoAn>
    <MapInfoRen
      v-show="infowindowren"
      :inrenYuanData="inrenYuanData"
      ref="infowindowren"
    ></MapInfoRen>
  </div>
</template>
<script>
import MapInfoQiao from './mapInfo.vue';
import MapInfoAn from './mapInfoan.vue';
import MapInfoRen from './mapInforen.vue';

export default {
  name: 'HomeMap',
  data() {
    return {
      map: null,
      markerList: [],
      markerLists: [],
      markerAnList: [],
      markerZaiList: [],
      radio1: '卫星',
      infowindow: false,
      infowindowan: false,
      infowindowren: false,
      infowData: {},
      inanjuanData: {},
      inrenYuanData: {},
      getlists: 1
    };
  },
  props: {
    facList: {
      type: Array,
      default: []
    },
    anjuanList: {
      type: Array,
      default: []
    },
    zaixianList: {
      type: Array,
      default: []
    }
  },
  components: { MapInfoQiao, MapInfoAn, MapInfoRen },
  watch: {
    facList: {
      deep: true,
      handler(newName, oldName) {
        if (newName != oldName) {
          this.addMarker();
        }
      }
    },
    anjuanList: {
      deep: true,
      handler(newName, oldName) {
        if (newName != oldName) {
          this.addMarkers();
        }
      }
    },
    zaixianList: {
      deep: true,
      handler(newName, oldName) {
        if (newName != oldName) {
          this.addMarkerss();
        }
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    //初始化地图
    init() {
      this.map = new AMap.Map('Map', {
        // mapStyle: "amap://styles/c39263cd8a72e6a697b238d3e49b7949",
        // zoom: 13,
        // expandZoomRange: true,
        // zooms: [10, 20],
        // resizeEnable: false, //是否监控地图容器尺寸变化
        // center: [120.23787796497345, 29.71048938024598],
        // viewMode: "2D",
        zoom: 14,
        expandZoomRange: true,
        zooms: [1, 20],
        resizeEnable: false, //是否监控地图容器尺寸变化
        center: [119.271224, 29.46911],
        viewMode: '2D',
        layers: [new AMap.TileLayer.Satellite()]
      });
    },
    changeMap() {
      if (this.radio1 == '普通') {
        this.map = new AMap.Map('Map', {
          zoom: 13,
          expandZoomRange: true,
          zooms: [1, 20],
          resizeEnable: false, //是否监控地图容器尺寸变化
          center: [119.271224, 29.46911],
          mapStyle: 'amap://styles/c39263cd8a72e6a697b238d3e49b7949',
          viewMode: '2D'
        });
        this.addMarker();
      } else {
        this.map = new AMap.Map('Map', {
          zoom: 13,
          expandZoomRange: true,
          zooms: [1, 20],
          resizeEnable: false, //是否监控地图容器尺寸变化
          center: [119.271224, 29.46911],
          viewMode: '2D',
          layers: [new AMap.TileLayer.Satellite()]
        });
        this.addMarker();
        this.addMarkers();
        this.addMarkerss();
      }
    },
    //设施添加图层
    addMarker() {
      let a = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40),
      });
      let b = new AMap.Icon({
        image: require('@/assets/image/layout/addr-orange.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40),
      });
      if (this.getlists == 2) {
        this.map.remove(this.markerList);
        this.map.remove(this.markerLists);
      }
      if (this.facList != undefined && this.facList.length > 0) {
        this.markerList = [];
        this.markerLists = [];
        // console.log(this.markerList);
        this.facList.forEach((ele) => {
          if (ele.latitude && ele.longitude && ele.latitude != 0 && ele.longitude != 0) {
            let marker;
            let left = ele.bridgeName.length;
            if (ele.bridgeName == '新安江大桥') {
              marker = new AMap.Marker({
                position: [ele.longitude, ele.latitude],
                // offset: iconStyle.offset,
                icon: b, // 添加 Icon 图标 URL
                title: '',
                data: ele,
                imageSize: new AMap.Size(30, 37)
              });
            } else {
              marker = new AMap.Marker({
                position: [ele.longitude, ele.latitude],
                // offset: iconStyle.offset,
                icon: a, // 添加 Icon 图标 URL
                title: '',
                data: ele,
                imageSize: new AMap.Size(30, 37)
              });
            }
            marker.setLabel({
              offset: new AMap.Pixel(-left - 15, -35),
              content: `<div class='text'><i></i><span class="line"></span><span>${ele.bridgeName}</span></div>`
            });
            if (ele.bridgeName == '新安江大桥') {
              marker.on('click', (e) => {
                this.infowindow = true;
                let data = e.target.w.data;
                console.log(JSON.parse(JSON.stringify(data)));
                this.infowData = data;
                this.changeMarkers(e);
                this.map.setCenter([data.longitude, data.latitude]);
                this.map.setZoom(16);
                //构建自定义信息窗体
                let infoWindow;
                infoWindow = new AMap.InfoWindow({
                  anchor: 'middle-left',
                  offset: new AMap.Pixel(10, 10),
                  content: this.$refs.infowindow.$el
                });
                var position = new AMap.LngLat(
                  Number(data.longitude),
                  Number(data.latitude)
                );
                infoWindow.open(this.map, position);
              });
            } else {
              marker.on('click', (e) => {
                this.infowindow = true;
                let data = e.target.w.data;
                console.log(JSON.parse(JSON.stringify(data)));
                this.infowData = data;
                this.changeMarker(e);
                this.map.setCenter([data.longitude, data.latitude]);
                this.map.setZoom(16);
                //构建自定义信息窗体
                let infoWindow;
                infoWindow = new AMap.InfoWindow({
                  anchor: 'middle-left',
                  offset: new AMap.Pixel(10, 10),
                  content: this.$refs.infowindow.$el
                });
                var position = new AMap.LngLat(
                  Number(data.longitude),
                  Number(data.latitude)
                );
                infoWindow.open(this.map, position);
              });
            }
            if (ele.bridgeName == '新安江大桥') {
              this.markerLists.push(marker);
            } else {
              this.markerList.push(marker);
            }
          }
        });
        this.map.add(this.markerList);
        this.map.add(this.markerLists);
      } else {
        this.map.remove(this.markerList);
        this.map.remove(this.markerLists);
        //   for (var i = 0; i < this.markerLists.length; i++) {
        //     this.markerLists[i].setMap(null);
        //   }
        // for (var i = 0; i < this.markerList.length; i++) {
        //   this.markerList[i].setMap(null);
        // }
      }
      this.getlists = 2;
    },
    //案件添加图层
    addMarkers() {
      let a = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      if (this.getlists == 2) {
        this.map.remove(this.markerAnList);
      }
      if (this.anjuanList != undefined && this.anjuanList.length > 0) {
        this.markerAnList = [];
        this.anjuanList.forEach((ele) => {
          console.log(ele);
          if (ele.lat && ele.lng && ele.lat != 0 && ele.lng != 0) {
            let marker;
            // let left = ele.locationdDescribe.length;
            marker = new AMap.Marker({
              position: [ele.lng, ele.lat],
              // offset: iconStyle.offset,
              icon: a, // 添加 Icon 图标 URL
              title: '',
              data: ele,
              imageSize: new AMap.Size(30, 37)
            });
            marker.setLabel({
              offset: new AMap.Pixel(0 - 6, -23)
              // content: `<div style='line-height: 100%;font-size: 14px;' class='text'>${ele.locationdDescribe}</div>`,
            });
            marker.on('click', (e) => {
              // console.log(e.target.w.data);
              // console.log(this.map);
              this.infowindowan = true;
              let data = e.target.w.data;
              this.inanjuanData = data;
              this.changeMarkeran(e);
              this.map.setCenter([data.lng, data.lat]);
              this.map.setZoom(16);
              //构建自定义信息窗体
              let infoWindowan;
              infoWindowan = new AMap.InfoWindow({
                anchor: 'top-center',
                offset: new AMap.Pixel(10, 10),
                content: this.$refs.infowindowan.$el
              });
              var position = new AMap.LngLat(Number(data.lng), Number(data.lat));
              infoWindowan.open(this.map, position);
            });
            this.markerAnList.push(marker);
          }
        });
        this.map.add(this.markerAnList);
      } else {
        this.map.remove(this.markerAnList);
        // for (var i = 0; i < this.markerAnList.length; i++) {
        //  console.log(11);
        //   this.markerAnList[i].setMap(null);
        // }
      }
    },
    //人员添加图层
    addMarkerss() {
      let a = new AMap.Icon({
        image: require('@/assets/image/maprenyuan.png'),
        size: new AMap.Size(37, 37), //图标大小
        imageSize: new AMap.Size(30, 37)
      });
      if (this.getlists == 2) {
        this.map.remove(this.markerZaiList);
      }
      if (this.zaixianList != undefined && this.zaixianList.length > 0) {
        this.markerZaiList = [];
        this.zaixianList.forEach((ele) => {
          console.log(ele);
          if (ele.longitude && ele.latitude && ele.latitude != 0 && ele.longitude != 0) {
            let marker;
            let left = ele.accountName.length;
            marker = new AMap.Marker({
              position: [ele.longitude, ele.latitude],
              // offset: iconStyle.offset,
              icon: a, // 添加 Icon 图标 URL
              title: '',
              data: ele,
              imageSize: new AMap.Size(30, 37)
            });
            marker.setLabel({
              offset: new AMap.Pixel(-left - 6, -23),
              content: `<div style='line-height: 100%;font-size: 14px;' class='text'>${ele.accountName}</div>`
            });
            marker.on('click', (e) => {
              // console.log(e.target.w.data);
              // console.log(this.map);
              this.infowindowren = true;
              let data = e.target.w.data;
              this.inrenYuanData = data;
              this.changeMarkerzai(e);
              this.map.setCenter([data.longitude, data.latitude]);
              this.map.setZoom(16);
              //构建自定义信息窗体
              let infoWindowren;
              infoWindowren = new AMap.InfoWindow({
                anchor: 'top-center',
                offset: new AMap.Pixel(10, 10),
                content: this.$refs.infowindowren.$el
              });
              var position = new AMap.LngLat(
                Number(data.longitude),
                Number(data.latitude)
              );
              infoWindowren.open(this.map, position);
            });
            this.markerZaiList.push(marker);
          }
        });
        this.map.add(this.markerZaiList);
      } else {
        this.map.remove(this.markerZaiList);
        // for (var i = 0; i < this.markerZaiList.length; i++) {
        //   this.markerZaiList[i].setMap(null);
        // }
      }
    },
    //修改选中点
    changeMarker(e) {
      let preIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      let clickIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      for (var i = 0; i < this.markerList.length; i++) {
        this.markerList[i].setIcon(preIcon);
      }
      e.target.setIcon(clickIcon);
    },
    changeMarkers(e) {
      let preIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-orange.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      let clickIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-orange.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      this.markerLists[0].setIcon(preIcon);
      e.target.setIcon(clickIcon);
    },
    changeMarkeran(e) {
      let preIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      let clickIcon = new AMap.Icon({
        image: require('@/assets/image/layout/addr-blue.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(40, 40)
      });
      for (var i = 0; i < this.markerAnList.length; i++) {
        this.markerAnList[i].setIcon(preIcon);
      }
      e.target.setIcon(clickIcon);
    },
    changeMarkerzai(e) {
      let preIcon = new AMap.Icon({
        image: require('@/assets/image/maprenyuan.png'),
        size: new AMap.Size(37, 37), //图标大小
        imageSize: new AMap.Size(30, 37)
      });
      let clickIcon = new AMap.Icon({
        image: require('@/assets/image/maprenyuans.png'),
        size: new AMap.Size(40, 40), //图标大小
        imageSize: new AMap.Size(33, 40)
      });
      for (var i = 0; i < this.markerZaiList.length; i++) {
        this.markerZaiList[i].setIcon(preIcon);
      }
      e.target.setIcon(clickIcon);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
#Map {
  width: 100%;
  height: 100%;
  position: absolute;
}
::v-deep .amap-info-sharp {
  display: none;
}
::v-deep .amap-logo {
  display: none !important;
}
::v-deep .amap-copyright {
  opacity: 0 !important ;
}
.radio {
  position: absolute;
  bottom: 100px;
  right: 500px;
  z-index: 99;
}
::v-deep .el-radio-button__inner {
  width: 46px;
  height: 26px;
  line-height: 26px;
  background-color: white !important;
  box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
  border-radius: 4px 0px 0px 4px;
  border: none;
  padding: 0;
  font-size: 16px;
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  width: 46px;
  height: 26px;
  line-height: 26px;
  background-color: #244793 !important;
  box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
  border-radius: 4px 0px 0px 4px;
  border: none;
  padding: 0;
  font-size: 16px;
}
::v-deep .text {
  color: white;
  border: 1px solid #1efffe;
  padding: 0 18px;
  background: linear-gradient(90deg, #14cfee 0%, #083794 100%);
  border-radius: 16px;
  font-size: 16px;
  line-height: 31px;
  display: flex;
  align-items: center;
  i {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAARRJREFUOE+tlNFRwzAQRPd1QAlQAaQCSAW4BKiAUAGhA+ggVAAdEDpIKoAS6GCZ81ge2ZGFM6A/nU7Pt3cro9Gy3Uh67cKPwNr2WtJDF7sHnsb3KIAi6a4CegFu5oC2ki4roB2wmAtKeRtgYzsq6KsArn4FjRPm7rEdUjz3QikPWAboT5AAE+s/QWlKz5K+j5AYDY/ptnaIisJsK+DE9krSdQ4L/YU+7iW9SXqXtAS2CXQBNN2F5KGWNyG/9ZLtUNC0oPzrpX5N9THig8rTxvappM8Do00PZAHsUn5PtR3NC82DVZnsbbi+BMpfeA+rgNo/QwkUUxhMrNLsOPrI31wuLfSeHyHtCzibknbgx+zHVjxLwR8cxZoTLCq0MwAAAABJRU5ErkJggg==')
      no-repeat;
    background-size: 17px auto;
    display: block;
    width: 17px;
    height: 17px;
  }
  .line {
    width: 2px;
    height: 16px;
    margin: 0 13px;
    background: #1effff;
  }
}
::v-deep .amap-marker-label {
  border: none;
  background: transparent;
  //background: rgba(0, 0, 0, 0.5);
}
::v-deep .amap-info-content {
  background: none;
  // background: rgba(3, 67, 79, 0.9);
  // border-radius: 10px;
  // border: 1px solid #1c9bb1;
  padding: 0;
  padding-left: 80px;
}
::v-deep .amap-info {
  // width: 300px;
  // height: 400px;
  background: rgba(8, 28, 64, 1);
}
::v-deep .amap-info-close {
  border-radius: 50%;
  // border: 1px solid #33b4f0;
  padding: 2px;
  top: 15px;
  right: 30px !important;
  color: #fff;
}
::v-deep .amap-info-close:hover {
  color: #59cde2;
}
</style>
